import { render, staticRenderFns } from "./LoginExtranet.vue?vue&type=template&id=69d1bf94&scoped=true&"
import script from "./LoginExtranet.ts?vue&type=script&lang=ts&"
export * from "./LoginExtranet.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d1bf94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69d1bf94')) {
      api.createRecord('69d1bf94', component.options)
    } else {
      api.reload('69d1bf94', component.options)
    }
    module.hot.accept("./LoginExtranet.vue?vue&type=template&id=69d1bf94&scoped=true&", function () {
      api.rerender('69d1bf94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/typo3conf/ext/aus_project/Resources/Private/TypeScript/LoginStatus/Components/LoginExtranet/LoginExtranet.vue"
export default component.exports